import { useLocation } from 'react-router';
import Cabecera from './cabecera';
import Contenido from './contenido';
import { useEffect } from 'react';

export const Payments = () => {
  const location = useLocation();
  const data = location.state ?? {};

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div
      className="minWebPadding"
      style={{
        backgroundColor: 'rgb(243, 243, 243)',
      }}
    >
      <Cabecera
        codeLoc={data.resultado ? data.resultado?.locator : null}
        email={data?.state?.contact?.email}
        code={data.code}
        isSuccessPayment={data.isSuccessPayment}
      />
      <Contenido datos={data} />
    </div>
  );
};
